import * as React from 'react';
export const n26Svg = React.forwardRef(function n26SvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#000',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'm4.36 13.77 4.56 7.03h1.26v-9.16H8.73v6.98L4.32 11.8l-.1-.16H2.9v9.16h1.45v-7.03zm12.9 3.36c1.7-.97 2.36-1.81 2.36-3 0-1.6-1.16-2.65-2.92-2.65-1.34 0-2.9.75-3.43 1.92l-.16.36 1 .44.16-.34c.36-.8 1.51-1.32 2.41-1.34 1.12 0 1.8.61 1.8 1.63 0 .66-.28 1.22-1.77 2.1-2.63 1.54-3.55 2.22-3.62 3.87v.68h6.5v-.93h-5.35c.1-.84.83-1.46 3.03-2.74zm8.63-2.28c-.83.02-1.64.3-2.3.79.18-1.97 1.1-3.13 2.52-3.13.62 0 1.24.22 1.69.64l.32.26.72-.8-.32-.28a3.73 3.73 0 0 0-2.41-.87c-2.26 0-3.64 1.9-3.64 4.9 0 3.4 1.75 4.6 3.4 4.6a3.08 3.08 0 0 0 3.22-3.14c0-2.2-1.73-2.97-3.2-2.97zm0 5.08c-.94 0-2.08-.76-2.28-2.88a3.24 3.24 0 0 1 2.28-1.17c1.88 0 2.08 1.36 2.08 1.94 0 1.05-.71 2.1-2.08 2.1zM2.91 21.82h7.27v.78H2.91v-.78zm0-12.42h7.27v.78H2.91V9.4z',
      }),
    ),
  );
});
n26Svg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var n26 = {
  category: 'brand',
  colorable: false,
  name: 'n26',
  svg: n26Svg,
};
